import { useState } from 'react';
import { toast } from 'react-toastify';

import Grid from '@material-ui/core/Grid';

import { Button, DatePicker } from 'components';
import { Field, Form, Formik } from 'formik';
import { downloadcsv } from 'helpers/downloadcsv';
import { PageTitle } from 'pages/Layout/PageTitle';
import { providersService } from 'services';

import { formatDate } from '../../../../helpers/formateDate';

export const ClosedOsReport = () => {
  const [isLoading, setIsLoading] = useState(false);
  const now = new Date();

  const handleExport = async (values) => {
    toast.info('Aguarde relatório sendo gerado');
    setIsLoading(true);

    try {
      const { data } = await providersService.closedOsReport({ values });
      const result = data.result;
      const date = await formatDate(now);

      if (data.status === 200) {
        toast.success(data.msg);
        await downloadcsv(`Relatório_OSs_Encerradas${date}`, result);
        setIsLoading(false);
      } else {
        toast.error(data.msg);
        setIsLoading(false);
      }
    } catch (error) {
      console.log(error.message);
      toast.error('Erro ao gerar relatório');
      setIsLoading(false);
    }
  };

  return (
    <>
      <PageTitle>OS`s Encerradas</PageTitle>

      <Formik
        initialValues={{ input_date: new Date(), output_date: new Date() }}
        onSubmit={handleExport}
      >
        {(props) => (
          <Form>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={3} md={3} lg={3}>
                <Field
                  size='small'
                  name='input_date'
                  label='Data de inicio'
                  variant='outlined'
                  fullWidth
                  inputVariant='outlined'
                  component={DatePicker}
                />
              </Grid>
              <Grid item xs={12} sm={3} md={3} lg={3}>
                <Field
                  size='small'
                  name='output_date'
                  label='Data Final'
                  variant='outlined'
                  fullWidth
                  inputVariant='outlined'
                  component={DatePicker}
                />
              </Grid>
              <Grid item xs={12} sm={3} md={3} lg={3}>
                <Button type='submit' fullWidth loading={isLoading}>
                  Extrair Relatório
                </Button>
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    </>
  );
};
